import { useState } from "react";
import { REQUIRED_GUIDANCE_SECTIONS } from "./utils";

const btnSecondary = {
    border: "1px solid var(--lighterGrey)",
    borderRadius: "0.35rem",
    padding: "0.45rem 0.9rem",
    fontSize: "0.875rem",
    cursor: "pointer",
    background: "var(--white)",
};

/**
 * Collapsible hint listing required guidance headings + insert-template action.
 * Default expanded on first render; collapse state is local only.
 */
const GuidanceSectionsHint = ({ onInsertTemplate }) => {
    const [expanded, setExpanded] = useState(true);

    return (
        <div style={{
            border: "1px solid var(--lighterGrey)",
            borderRadius: "0.35rem",
            background: "var(--lightestGrey)",
            overflow: "hidden",
        }}>
            <button
                type="button"
                onClick={() => setExpanded((v) => !v)}
                aria-expanded={expanded}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "0.75rem",
                    width: "100%",
                    margin: 0,
                    padding: "0.75rem 1rem",
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    textAlign: "left",
                    fontFamily: "inherit",
                }}
            >
                <span style={{
                    fontSize: "0.9rem",
                    fontWeight: 600,
                    color: "var(--black)",
                }}>
                    Guidance must include these sections
                </span>
                <span
                    aria-hidden
                    style={{
                        fontSize: "0.75rem",
                        color: "var(--darkGrey)",
                        flexShrink: 0,
                    }}
                >
                    {expanded ? "▾" : "▸"}
                </span>
            </button>

            {expanded && (
                <div style={{
                    padding: "0 1rem 0.9rem",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.75rem",
                }}>
                    <ul style={{
                        margin: 0,
                        paddingLeft: "1.1rem",
                        fontSize: "0.85rem",
                        color: "var(--darkGrey)",
                        lineHeight: 1.45,
                    }}>
                        {REQUIRED_GUIDANCE_SECTIONS.map((section) => (
                            <li key={section.heading}>
                                <code style={{ fontSize: "0.8rem", color: "var(--black)" }}>
                                    {section.heading}
                                </code>
                                {" — "}
                                {section.tip}
                            </li>
                        ))}
                    </ul>
                    {typeof onInsertTemplate === "function" && (
                        <div>
                            <button
                                type="button"
                                style={btnSecondary}
                                onClick={onInsertTemplate}
                            >
                                Insert starter template
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default GuidanceSectionsHint;
